export const isIE = () => {
  const ua = navigator.userAgent
  const msie = ua.indexOf('MSIE ')
  const trident = ua.indexOf('Trident/')
  const edge = ua.indexOf('Edge/')

  return msie > 0 || trident > 0 || edge > 0
}

export const isFirefox = () => {
  return /firefox/i.test(navigator.userAgent)
}

export const isOsx = () => {
  return /OS X.*/i.test(navigator.userAgent)
}
